import React from "react";
import Header from "../../components/myaniture/layouts/header";
import Banner from "../../components/myaniture/home/banner";
import Rules from "../../components/myaniture/home/rules";
import BestSelling from "../../components/myaniture/home/best_selling";
import ShopByCat from "../../components/myaniture/home/shopbycat";
import Promo from "../../components/myaniture/home/promo";
import NewPd from "../../components/myaniture/home/newpd";
import { SlideData } from "../../template_codes/whisky_house/home_page";
import { newPd } from "../../template_codes/myaniture/myaniture";
import CardSlide from "../../components/myaniture/home/card_slide";
const HomePage = () => {
  return (
    <div className="overflow-hidden 2xl:container mx-auto">
      <Header SlideData={newPd} />
      <Banner />
      <NewPd SlideData={newPd} />
      <ShopByCat />
      <Promo />
      <CardSlide SlideData={newPd} title={"Best Selling"} />
      <Rules />
    </div>
  );
};

export default HomePage;
